import { processJsonString } from './stringProcess'
import { getBridgeWindow, setBridgeWindow } from './uaConfig'

const setupWebViewJavascriptBridge = (callback: (bridge: any) => void): boolean => {
  console.log('UnityBridge: 开始创建桥接函数', window)
  if ((window as any).Unity) {
    callback((window as any).Unity)
    return true
  } else {
    console.error('UnityBridge: 创建桥接函数失败')
    return false
  }
}

const checkCallbackFunction = (message: string, callbackName: string, callbackData: any): boolean => {
  const name = message.split('&')[0]
  const paramStr = message.split('&')[1]
  if (name === callbackName && name === 'h5Req') {
    try {
      const params = JSON.parse(paramStr)
      const callbackParams = processJsonString(callbackData)
      if (!callbackParams) {
        console.error('UnityBridge: h5Req回调参数解析失败', callbackData)
        return false
      }
      if (Number(params.reqId) === Number(callbackParams.reqId)) {
        return true
      } else {
        return false
      }
    } catch (error) {
      console.error('UnityBridge: h5Req提交参数解析失败', error)
      return false
    }
  } else if (name === callbackName) {
    return true
  }
  return false
}

const handleCallbackFunction = (callbackName: string, callbackData: any): void => {
  const bridge = getBridgeWindow()
  if (!bridge?.callbackQueue) {
    return
  }
  const callbacks = bridge.callbackQueue
  let callbackIndex = -1
  for (let i = 0; i < callbacks.length; i++) {
    const callback = callbacks[i]
    const message = callback.message
    if (checkCallbackFunction(message, callbackName, callbackData)) {
      callback.callback(callbackName, callbackData)
      callbackIndex = i
      break
    }
  }
  if (callbackIndex !== -1) {
    bridge.callbackQueue.splice(callbackIndex, 1)
  }
}

const initWebViewJavascriptBridge = (callback?: () => void): void => {
  const bridge = getBridgeWindow()
  if (!bridge || !bridge.Callback) {
    setBridgeWindow({
      callbackQueue: [],
      Callback: (callbackName: string, callbackData: any) => {
        handleCallbackFunction(callbackName, callbackData)
      },
      RegisterUnityMethod: (methodName: string, methodFunction: Function) => {
        getBridgeWindow()[methodName] = methodFunction
      }
    })
    console.log('UnityBridge: 初始化Unity连接')
  } else {
    bridge.Callback = (callbackName: string, callbackData: any) => {
      handleCallbackFunction(callbackName, callbackData)
    }
  }

  if (callback) {
    callback()
  }
}

const UnityBridge = {
  registerHandler(methodName: string, methodFunction: Function): void {
    initWebViewJavascriptBridge(() => {
      const bridge = getBridgeWindow()
      if (bridge) {
        bridge.RegisterUnityMethod(methodName, methodFunction)
      } else {
        console.error('UnityBridge: Unity 桥接未初始化')
      }
    })
  },

  callHandler(message: string, callback: (callbackName: string, data: any) => void): void {
    const result = setupWebViewJavascriptBridge((bridge: any) => {
      console.log('UnityBridge: 发送message', message)

      initWebViewJavascriptBridge(() => {
        getBridgeWindow().callbackQueue.push({
          callback: (callbackName: string, data: any) => {
            callback(callbackName, data)
          },
          message: message
        })
        bridge.call(message)
      })
    })

    if (!result) {
      // eslint-disable-next-line standard/no-callback-literal
      callback('', null)
    }
  }
}

export default UnityBridge
